type GetHeroStringForTelemetry = (hero: string[]) => string;
export const getHeroStringForTelemetry: GetHeroStringForTelemetry = (hero) => hero.join(',');

type HasHeroMatch = (component: string, hero: string[]) => boolean;
export const hasHeroMatch: HasHeroMatch = (component, hero) => hero.includes(component);
